import { PickupParticipantDetailPage } from "components/shared/pickupParticipants";
import { InformationSection } from "./components/detail/informationSection";
import { PickupInformationSection } from "./components/detail/pickupInformation";
import { RegistrationInformationSection } from "./components/detail/registrationInformationSection";

export const PickupAttractionParticipantDetail: React.FC = () => (
  <PickupParticipantDetailPage
    kind="attraction"
    variant="admin"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);
